import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import GetInvolved from "../pages/get-involved/page";
import Programs from "../pages/programs/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/get-involved",
    element: <GetInvolved />,
  },
  {
    path: "/programs",
    element: <Programs />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
